<template>
  <svg
    class="hadrian-icons disability"
    version="1.1"
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    viewBox="12.231 141 389.538 512"
    style="enable-background: new 12.231 141 389.538 512"
    xml:space="preserve"
  >
    <g>
      <path
        d="M367.382,466.79c-3.722-14.89-17.047-25.287-32.394-25.287h-64.876c-9.178-15.069-21.144-28.282-35.291-38.91v-94.647
		c0-25.164-26.951-40.553-48.323-29.868l-66.778,33.389c-11.385,5.69-18.344,17.135-18.344,29.868v42.705
		c-0.207,0.071-0.417,0.094-0.622,0.174c-53.773,21.003-88.521,71.886-88.521,129.632c0,76.713,62.409,139.122,139.122,139.122
		c77.23,0,142.093-63.95,138.875-144.687h18.691l27.063,119.4c4.459,17.802,22.381,28.848,40.498,24.292
		c17.852-4.462,28.748-22.629,24.292-40.498L367.382,466.79z M151.353,619.579c-58.301,0-105.732-47.432-105.732-105.732
		c0-39.568,21.583-74.727,55.754-92.997v42.913c0,18.412,14.866,33.389,33.278,33.389s33.389-14.977,33.389-33.389v-54.647
		c0.826,0.292,1.658,0.574,2.549,0.738c50.116,9.205,86.495,52.942,86.495,103.994C257.085,572.147,209.654,619.579,151.353,619.579
		z"
      />
      <path
        d="M257.085,191.084c0-27.617-22.466-50.084-50.084-50.084s-50.084,22.466-50.084,50.084s22.466,50.084,50.084,50.084
		S257.085,218.701,257.085,191.084z"
      />
    </g>
  </svg>
</template>
